<template>
  <div class="rm-drawer-step">
    <div class="rm-drawer-scroll">
      <section class="drawer-section">
        <h3 class="drawer-section-title">
          {{ $t('ESTIMATE_REPAIRER_DETAIL.SUB_TITLE.SUMMARY') }}
        </h3>
        <v-card-secondary
          v-for="offer of currentRepairFile?.repairer_estimate?.repairer_estimate_option_list"
          :key="offer.technical_id"
          class="secondary-card-row pa-3"
        >
          <p class="drawer-offer-label">
            {{ $t('COMMON.PRODUCT_END_STATUS.' + offer.offer_type.toUpperCase()) }}
          </p>
          <p class="drawer-offer-price">
            {{ Number(offer.total_cost).toFixed(2) }} {{ $t('COMMON.EURO') }}
          </p>
        </v-card-secondary>
      </section>

      <section class="drawer-section">
        <h3 class="drawer-section-title">
          {{ $t('ESTIMATE_REPAIRER_DETAIL.SUB_TITLE.INFORM_CLIENT') }}
        </h3>
        <div class="drawer-field">
          <p class="custom-label">{{ $t('ESTIMATE_REPAIRER_DETAIL.CALL_CLIENT') }}</p>
          <v-text-field
            :model-value="currentRepairFile?.phone_number"
            hide-details
            readonly
            prepend-inner-icon="mdi-phone-outline"
          />
        </div>
        <div class="drawer-field">
          <p class="custom-label">{{ $t('ESTIMATE_REPAIRER_DETAIL.SEND_ESTIMATE') }}</p>
          <v-text-field
            v-model="email"
            required
            :rules="[...requiredRules, ...emailRules]"
            hide-details="auto"
            :placeholder="$t('ESTIMATE_REPAIRER_DETAIL.PLACEHOLDER.COMMENT')"
            prepend-inner-icon="mdi-email-outline"
          />
        </div>
        <v-btn-secondary
          class="w-100"
          :disabled="loading"
          :loading="loading"
          prepend-icon="mdi-send-outline"
          variant="flat"
          @click="sendClientEmail"
        >
          {{ $t('ESTIMATE_REPAIRER_DETAIL.BUTTON.SEND_EMAIL') }}
        </v-btn-secondary>
      </section>
    </div>
  </div>
</template>

<script>
import ResponseConstant from '@/constants/responseConstant'
import { displayToast, handleResponseError } from '@/utils/toastUtils'
import Validators from '@/utils/validators'
import RepairFileService from '@/services/RepairFileService'
import EstimateRepairerService from '@/services/EstimateRepairerService'

export default {
  props: { currentRepairFile: Object },
  data() {
    return {
      loading: false,
      error: null,
      requiredRules: Validators.requiredRules,
      emailRules: Validators.emailRules,
      email: null
    }
  },
  computed: {
    footerState() {
      return { disabled: this.loading, loading: this.loading }
    }
  },
  created() {
    this.email = this.currentRepairFile?.email
  },
  mounted() {
    this.emitFooterState()
  },
  watch: {
    footerState: {
      handler() {
        this.emitFooterState()
      },
      deep: true
    }
  },
  methods: {
    emitFooterState() {
      this.$emit('updateFooterState', this.footerState)
    },
    submit() {
      return this.submitSaveEmail()
    },
    async submitSaveEmail() {
      if (this.email !== this.currentRepairFile.email) {
        this.loading = true
        try {
          await RepairFileService.updateRepairFileEmail({
            repair_file_id: this.currentRepairFile.technical_id,
            contact_email: this.email
          })
          displayToast(this.$t('ESTIMATE_REPAIRER_DETAIL.CUSTOMER_EMAIL_SAVE'), 'success')
          this.$emit('updateCurrentRepairFile')
        } catch (error) {
          handleResponseError(error)
          if (error.response?.data?.key in ResponseConstant) this.setError(error.response.data.key)
          return
        } finally {
          this.loading = false
        }
      }
      this.$emit('openEstimateRepairerClientChoice')
    },
    setError(key) {
      if (key === 'invalid_repairer_repair_file_number_error_key') {
        this.error = { repairerNumber: this.$t('ERROR.' + ResponseConstant[key]) }
        return
      }
      this.error = ''
    },
    async sendClientEmail() {
      this.loading = true
      try {
        await RepairFileService.sendRepairFileRepairerEstimateToClient({
          repair_file_id: this.currentRepairFile.technical_id,
          contact_email: this.email
        })
        displayToast(this.$t('ESTIMATE_REPAIRER_DETAIL.MODAL.SEND_CLIENT_EMAIL'), 'success')
        this.$emit('updateCurrentRepairFile')
        this.$emit('closeNewAction')
      } catch (error) {
        handleResponseError(error)
        if (error.response?.data?.key in ResponseConstant) this.setError(error.response.data.key)
      } finally {
        this.loading = false
      }
    },
    async backToRepairerOffersCreation() {
      this.loading = true
      try {
        await EstimateRepairerService.backToRepairerOffersCreation(
          this.currentRepairFile.technical_id
        )
        this.$emit('backToRepairerOffersCreation')
      } catch (error) {
        handleResponseError(error)
        if (error.response?.data?.key in ResponseConstant) this.setError(error.response.data.key)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
